module.exports = __webpack_public_path__ + "img/code.83fc6c8a.png";